import { ListaModelos } from './../../../_entities/dispositivos/AgregarDispositivoVM';
import { ListaMarcas } from './../../../_entities/medidores/MarcasMedidores';
import { SimVM } from './../../../_entities/sims/SimVM';
import { AgregarDispositivoSinSimVM } from './../../../_entities/dispositivos/AgregarDispositivoVM';
import { ClienteVM } from './../../../_entities/clientes/ClienteVM';
import { environment } from './../../../../environments/environment';
import { DispositivoVM, FormDataDispositivoVM } from './../../../_entities/dispositivos/DispositivoVM';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DispositivosDisponibles } from './../../../_entities/Administracion/DispositivosDisponibles';

@Injectable({
	providedIn: 'root'
})
export class DispositivoService {

	constructor(private http: HttpClient) { }

	obtenerDispositivos(): Observable<DispositivoVM[]> {
		return this.http.get<DispositivoVM[]>(`${environment.API_SECURITY}/api/dispositivos`);
	}

	obtenerDispositivo(imei): Observable<FormDataDispositivoVM> {
		return this.http.get<FormDataDispositivoVM>(`${environment.API_SECURITY}/api/dispositivos/${imei}`);
	}

	obtenerSimsDisponibles(): Observable<SimVM[]> {
		return this.http.get<SimVM[]>(`${environment.API_SECURITY}/api/sims/disponibles`);
	}

	obtenerSimById(idSim): Observable<SimVM> {
		return this.http.get<SimVM>(`${environment.API_SECURITY}/api/sims/${idSim}`);
	}

	obtenerMarcas(): Observable<ListaMarcas[]> {
		return this.http.get<ListaMarcas[]>(`${environment.API_SECURITY}/api/marcasEquipo`);
	}

	obtenerModeloByMarca(idMarca): Observable<ListaModelos> {
		return this.http.get<ListaModelos>(`${environment.API_SECURITY}/api/ModelosEquipo/getmodelos/${idMarca}`);
	}

	getImeisDisponibles(): Observable<DispositivosDisponibles[]> {
		return this.http.get<DispositivosDisponibles[]>(environment.API_SECURITY + '/api/dispositivos/getbyestatus/1');
	}

	obtenerClientes(incluirClientePropietario: boolean = false): Observable<ClienteVM[]> {
		return this.http.get<ClienteVM[]>(`${environment.API_SECURITY}/api/Reportes/ClientesReportes`);
	}

	actualizarDispositivo(imei, form): Observable<any> {
		return this.http.put<any>(`${environment.API_SECURITY}/api/dispositivos/${imei}`, form);
	}

	agregarDispositivo(form): Observable<AgregarDispositivoSinSimVM> {
		return this.http.post<AgregarDispositivoSinSimVM>(`${environment.API_SECURITY}/api/dispositivos`, form);
	}

	cambiarEstatus(imei, estatus) {
		return this.http.put(environment.API_SECURITY + '/api/dispositivos/CambiarEstatus', null, {
			params: {
				imei,
				estatus
			}
		})
	}

	/**Eliminar sin sim
	* Luis Enrique
   */
	eliminarSinSim(imei) {
		return this.http.delete(environment.API_SECURITY + '/api/dispositivos/' + imei);
	}

	/**Eliminar con sim  y se elimina sim
	* Luis Enrique
	*/
	eliminarSim(imei, seElimina) {
		return this.http.delete(environment.API_SECURITY + '/api/dispositivos/' + imei, {
			params: {
				seElimina
			}
		});
	}

	/**Eliminar con sim  y se deja  sim
	* Luis Enrique
	*/
	eliminarNoSim(imei, seElimina) {
		return this.http.delete(environment.API_SECURITY + '/api/dispositivos/' + imei, {
			params: {
				seElimina
			}
		});
	}
}
